
<div *ngIf="loadingspinner == true" class="spin"></div>


<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">
  <div class="d-flex flex-wrap" *ngIf="token">
    <div class="two-card common-padding add-money shadow">
      <button class="btn btn-primary" style="float: right;" (click)="Back()">Back</button>
      &nbsp;
      <h2 class="heading">Add Gift Voucher</h2>
      <div class="row no-gutters">
        <div class="col-md-12">
          <div class="row no-gutters">
          
            <div class="col-12 form-padding">
              <form class="example-form" (ngSubmit)="AddmobileMoneyForm(AddMoneyForm.value)" [formGroup]="AddMoneyForm">
                <div class="row no-gutters">
                  <div class="col-md-12">
                    <div class="row no-gutters">

                      <div class="col-12">

                        <mat-radio-group aria-label="Select an option" aria-labelledby="example-radio-group-label" class="example-radio-group">
                          <mat-radio-button value="hdfc" (change)="changeMethodpayment($event)" class="example-radio-button">
                            Option 1 - HDFC Bank
                          </mat-radio-button>

                          <!--<mat-radio-button value="easebuzz" (change)="changeMethodpayment($event)" class="example-radio-button">Option 2 - Easebuzz</mat-radio-button>-->

                        </mat-radio-group>

                      </div>

                      <div class="col-12">

                        <mat-form-field class="example-full-width">
                          <mat-label>Select Voucher</mat-label>
                          <mat-select formControlName="accountServiceId" required>
                            <mat-option [value]="d?.Id" *ngFor="let d of VoucherList; let i=index" (click)="changeMethod(d);">
                              {{d?.Name}}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="submitted && f.accountServiceId?.errors?.required">
                            Select Voucher
                          </mat-error>
                        </mat-form-field>




                      </div>


                    </div>

                    </div>
                  <div class="col-12">
                    <button class="primary-btn" type="submit" style="margin-top: 20px;background-color:#f44a4a;"> Submit</button>
                  </div>
                 
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-12 mt-4">
          <div class="pay-detail text-center">
            <div class="icon_wrap">
              <i class="icon-payment_secure"></i>
            </div>
            <span class="ng-binding">Your payment details are secured</span>
          </div>
        </div>
      </div>
    </div>
   
  </div>

</fieldset>
